const ResumeTypes = {
    FETCH_START:    '[CASHIERS][RESUME] FETCH START',
    FETCH_SUCCESS:  '[CASHIERS][RESUME] FETCH SUCCESS',
    FETCH_FAILURE:  '[CASHIERS][RESUME] FETCH FAILURE'
};

export default ResumeTypes;